export default "__VITE_ASSET___anIsk1M__"